export default __webpack_public_path__ + "static/media/benefit_7@2x.1d3ffce1.png";